import qs from 'qs';
import {merge} from 'lodash';

export default {
  data() {
    return {
      IMAGE_PUBLIC_URL: process.env.IMAGE_PUBLIC_URL,
      IMAGE_PROJECT_URL: process.env.IMAGE_PROJECT_URL,

      /**
       * @see https://console.imageflux.jp/docs/image/conversion-parameters
       */
      DEFAULT_OPTIONS: {},
      PROJECT_PATHS: [
        '/images/bootstrap-ko',
        '/lp/images',
      ],
      EXTENSION_WHITELIST: [
        'jpeg',
        'jpg',
        'png',
        'gif',
      ],
      FORMAT_WHITELIST: [
        'jpg',
        'png',
        'gif',
        'auto',
      ],
    }
  },

  methods: {
    /**
     * 画像のurlをサービス用にformat
     */
    src(
      url,
      wxh = null,
      format = null,
      options = null
    ){
      const image_type = this.guessImageType(url);
      if (! image_type) {
        return url;
      }

      const size = this.formatSize(wxh);
      const parameters = merge(this.DEFAULT_OPTIONS, {
        f: 'webp:' + (this.FORMAT_WHITELIST.includes(format) ? format : image_type.format),
        w: size.width,
        h: size.height,
      });

      if (options) {
        options.split(',').forEach(kv => {
          const option = kv.split('=');
          if (option.length === 2) {
            parameters[option[0]] = option[1] || null;
          }
        });
      }

      const parameters_string = qs.stringify(parameters, {
        skipNulls: true,
        delimiter: '%2c'
      });

      const result = url.match(/^https?:\/\/(.+)/);
      const path = result ?
        `/${result[1].split('/').slice(1).join('/')}` :
        /^\//.test(url) ? url : `/${url}`;

      return `${image_type.url}/c/${parameters_string}${path}`;
    },

    /**
     * 画像のタイプを推定する
     */
    guessImageType(url) {
      if (process.env.APP_ENV === 'local' || ! new RegExp('\.(' + this.EXTENSION_WHITELIST.join('|') + ')$').test(url)) {
        return null;
      }

      if (new RegExp('^' + this.IMAGE_PUBLIC_URL.replace(/\./g, '\\.')).test(url)) {
        return {
          url: this.IMAGE_PUBLIC_URL,
          format: 'jpg',
        };
      } else if (this.IMAGE_PROJECT_URL && new RegExp('^(' + this.PROJECT_PATHS.join('|').replace(/\//g, '\\/') + ')$').test(/^\//.test(url) ? url : `/${url}`)) {
        return {
          url: this.IMAGE_PROJECT_URL,
          format: 'auto',
        };
      }

      return null
    },

    /**
     * 画像のサイズ情報を整える
     */
    formatSize(wxh = null) {
      if (! wxh) {
        return {};
      }

      const wh = wxh.split('x');
      if (wh.length !== 2) {
        return {};
      }

      return {
        'width': parseInt(wh[0]) || null,
        'height': parseInt(wh[1]) || null,
      };
    },
  }
};
